import React from "react";
import { useNavigate, Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { getAuth } from "firebase/auth";

function CollegeCareerPaths() {
  const navigate = useNavigate();
  const auth = getAuth();

  const handleStart = () => {
    if (auth.currentUser) {
      navigate("/");
    } else {
      navigate("/get-started");
    }
  };

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto" }}>

      <SEOHead
        title="PAGE TITLE HERE"
        description="PAGE DESCRIPTION HERE"
        canonical="https://employpilot.com/college-career-path"
      />

      <h1>Best Career Paths for College Students (2026 Guide)</h1>

      <p style={{ fontSize: "18px", color: "#555" }}>
        Choosing a career path as a college student can feel overwhelming.
        With so many options, it’s easy to feel unsure about what direction to take.
      </p>

      <p style={{ fontWeight: "bold", marginTop: "15px" }}>
        The best career path is one that aligns with your skills, interests, and long-term goals.
      </p>

      <button onClick={handleStart} style={btnPrimary}>
        Explore My Career Path
      </button>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>How to Choose the Right Career Path</h2>

      <ul>
        <li>✔ Identify your strengths and interests</li>
        <li>✔ Research industries and job demand</li>
        <li>✔ Consider long-term growth opportunities</li>
        <li>✔ Gain real experience through internships</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Popular Career Paths for College Students</h2>

      <h3>Technology</h3>
      <p>
        Roles in software development, data analysis, and IT continue to grow rapidly and offer strong salaries.
      </p>

      <h3>Business & Finance</h3>
      <p>
        Careers in finance, consulting, and management provide stability and opportunities for advancement.
      </p>

      <h3>Healthcare</h3>
      <p>
        Healthcare careers offer long-term demand and meaningful work across many roles.
      </p>

      <h3>Marketing & Media</h3>
      <p>
        Digital marketing, content creation, and branding are growing fields with flexible career paths.
      </p>

      <h3>Skilled Trades & Entrepreneurship</h3>
      <p>
        Not all careers require traditional paths—entrepreneurship and skilled trades offer strong earning potential.
      </p>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>How to Start Building Your Career Now</h2>

      <ol>
        <li>Build relevant skills</li>
        <li>Create a strong resume</li>
        <li>Apply for internships or entry-level roles</li>
        <li>Network with professionals</li>
      </ol>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Mistakes to Avoid</h2>

      <ul>
        <li>❌ Waiting until graduation to prepare</li>
        <li>❌ Choosing a path based only on money</li>
        <li>❌ Not gaining real-world experience</li>
        <li>❌ Ignoring skill development</li>
      </ul>

      {/* INTERNAL LINKS */}
      <p style={{ marginTop: "20px" }}>
        Need help deciding?{" "}
        <Link to="/ai-career-advisor">
          Use the AI Career Advisor
        </Link>
      </p>

      <p>
        Ready to build your resume?{" "}
        <Link to="/ai-resume-builder">
          Start your resume here
        </Link>
      </p>

      <p>
        Preparing for interviews?{" "}
        <Link to="/interview-questions">
          Practice interview questions
        </Link>
      </p>

      {/* COMMUNITY CTA */}
      <p style={{ marginTop: "30px" }}>
        Want advice from other students and job seekers?{" "}
        <strong>Join the EmployPilot Community</strong> and learn from real experiences.
      </p>

      <p style={{ fontSize: "14px", color: "#777" }}>
        (Free account required)
      </p>

      <Link to="/community">
        Explore the Community
      </Link>

      {/* CTA */}
      <div style={{ marginTop: "50px", textAlign: "center" }}>
        <h2>Start Building Your Future Today</h2>

        <button onClick={handleStart} style={btnSuccess}>
          Get Started Free
        </button>
      </div>

      {/* FAQ */}
      <h2 style={{ marginTop: "60px" }}>
        Frequently Asked Questions
      </h2>

      <h3>What is the best career path for college students?</h3>
      <p>
        The best path depends on your interests, skills, and goals. High-growth fields include tech, healthcare, and business.
      </p>

      <h3>When should I start preparing for my career?</h3>
      <p>
        As early as possible. Building skills and experience during college gives you a major advantage.
      </p>

      <h3>Can AI help me choose a career?</h3>
      <p>
        Yes. Tools like EmployPilot can guide you based on your interests and strengths.
      </p>
<div
    style={{
      marginTop: "80px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
      borderTop: "1px solid #eee",
      paddingTop: "30px"
    }}
  >
    © 2026 EmployPilot. All Rights Reserved.

    <div style={{ marginTop: "10px" }}>
      <a href="/terms" style={{ margin: "0 10px" }}>
        Terms of Use
      </a>

      <a href="/privacy" style={{ margin: "0 10px" }}>
        Privacy Policy
      </a>

      <a href="/contact" style={{ margin: "0 10px" }}>
        Contact
      </a>
    </div>
  </div>
</div>
  );
}

const btnPrimary = {
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "12px 20px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  marginTop: "20px"
};

const btnSuccess = {
  backgroundColor: "#28a745",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer"
};

export default CollegeCareerPaths;